import React from "react"
import { Helmet } from "react-helmet"
import { useEffect } from "react"

export function Metadata() {
  useEffect(() => {
    const googleAnalytics = () => {
      ;(function (w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" })
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : ""
        j.async = true
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl
        f.parentNode.insertBefore(j, f)
      })(window, document, "script", "dataLayer", "GTM-N6GX8LS")
    }
    googleAnalytics()
  }, [])

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>
        India’s unreal estate: Why you still can’t afford to buy that home
      </title>
      <meta name="author" content="Vivek Kaul" />
      <meta name="news_keywords" content="India's real estate, vivek kaul" />
      <meta
        name="description"
        content="Are you wondering if home prices will fall in the post-Covid world? There’s something you should know: the real estate industry in India doesn’t want this to happen."
      />
      <meta
        name="title"
        content="India’s unreal estate: Why you still can’t afford to buy that home"
      />
      <meta property="og:type" content="article" />
      <meta
        property="og:url"
        content="https://www.newslaundry.com/sena/indias-real-estate"
      />
      <meta
        property="og:title"
        content="India’s unreal estate: Why you still can’t afford to buy that home"
      />
      <meta
        property="og:description"
        content="Are you wondering if home prices will fall in the post-Covid world? There’s something you should know: the real estate industry in India doesn’t want this to happen."
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="India’s unreal estate: Why you still can’t afford to buy that home"
      />
      <meta
        name="twitter:description"
        content="Are you wondering if home prices will fall in the post-Covid world? There’s something you should know: the real estate industry in India doesn’t want this to happen."
      />
      <meta
        name="twitter:image"
        content="https://images.assettype.com/newslaundry/2020-07/2ef2263e-4474-4078-87d1-2dc218dbe934/01__1_.jpg?w=1200&auto=format%2Ccompress&ogImage=true"
      />
      <meta
        property="og:image"
        content="https://images.assettype.com/newslaundry/2020-07/2ef2263e-4474-4078-87d1-2dc218dbe934/01__1_.jpg?w=1200&auto=format%2Ccompress&ogImage=true"
      />
      <meta property="og:image:width" content="1200" />
      <meta name="twitter:site" content="Newslaundry" />
      <meta name="twitter:domain" content="https://www.newslaundry.com" />
      <meta property="fb:app_id" content="292331211112295" />
      <meta property="og:site_name" content="Newslaundry" />
      <link
        rel="canonical"
        href="https://www.newslaundry.com/sena/indias-real-estate/"
      />

      <link
        rel="preconnect dns-prefetch"
        href="//www.googletagservices.com"
        crossorigin
      />
    </Helmet>
  )
}
